import { render, staticRenderFns } from "./component-summary.vue?vue&type=template&id=42574b6e&scoped=true&"
import script from "./component-summary.vue?vue&type=script&lang=js&"
export * from "./component-summary.vue?vue&type=script&lang=js&"
import style0 from "./component-summary.vue?vue&type=style&index=0&id=42574b6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42574b6e",
  null
  
)

export default component.exports